/**
 * Groesse der Oberflaeche (Schrift, Knoepfe, Abstaende) – je Person.
 *
 * Umgesetzt mit CSS `zoom` ueber die Variable --ui-zoom, und zwar nur fuer
 * Leiste, Kopfzeile, Dialoge und Ansichten OHNE Zeichenflaeche. Das Lead
 * Sheet hat seine eigene Schriftgroesse (A− / A+), und die Zeichenebene
 * rechnet mit Bildschirmkoordinaten – dort bleibt es bei 1.
 */
export const UI_SCALES = [
  { value: 0.85, label: 'Klein' },
  { value: 0.92, label: 'Kompakt' },
  { value: 1, label: 'Normal' },
  { value: 1.12, label: 'Groß' },
];

export const DEFAULT_UI_SCALE = 0.92;

export function applyUiScale(scale: number | undefined): void {
  const value = scale && scale > 0.5 && scale < 2 ? scale : DEFAULT_UI_SCALE;
  document.documentElement.style.setProperty('--ui-zoom', String(value));
}
